<template>
  <div class="data-categorisation">
    <MobileNav :page_title="nav_title" />

    <!-- <span class="page-container" > -->
    <LivePriceTickerVue v-if="!isMobile"></LivePriceTickerVue>

    <!-- Left Section for Desktop View -->
    <DataCategorisationLeftSection v-if="!isMobile" v-loading="isRecoListLoading" />

    <!-- Right Section -->
    <div class="right-section" v-loading="isRecoListLoading">
      <template v-if="!isMobile" style="margin-top: 40px">
        <!-- Desktop View Components Sequence -->
        <div class="component-container" style="margin-top: 2px">
          <LatestRecommendations :recommendations="latestRecos" :isRecoListLoading="isRecoListLoading" @get_reco_details="recoDetails" />
        </div>

        <div class="component-container">
          <StampListComponent :stampList="stamp_list" :isRecoListLoading="isRecoListLoading" />
        </div>

        <div class="component-container">
          <MarketCapRecommendations :marketCapRecommendations="marketCapRecommendations" :isRecoListLoading="isRecoListLoading" />
        </div>

        <el-row class="component-container" :gutter="20">
          <el-col :span="12" class="responsive-col">
            <PriceRangeWiseRecos :stocksFromMainPage="priceRangeWiseStocks" @get_reco_details="recoDetails" />
          </el-col>
          <el-col :span="12" class="responsive-col">
            <TopPotentialStockStrategy :recommendations="topPotentialRecommendations" :recoCount="topPotentialRecoCount" :expertView="'Equity'" :isRecoListLoading="isRecoListLoading" @get_reco_details="recoDetails"></TopPotentialStockStrategy>
            <!-- <TopPotentialStockStrategy :strategies="topPotentialStrategyList" :expertView="'Options'" :isRecoListLoading="isRecoListLoading"></TopPotentialStockStrategy> -->
            <!-- <TopPotentialStocks /> -->
          </el-col>
        </el-row>

        <el-row class="flex-sections component-container" :gutter="20">
          <el-col :span="12" class="responsive-col">
            <ChatWithExperts :expert_list="chatExpertList" />
          </el-col>
          <el-col :span="12" class="responsive-col">
            <MtfApprovedRecos :mtfApprovedStocks="mtfApprovedStocks" @get_reco_details="recoDetails" />
          </el-col>
        </el-row>
      </template>

      <template v-else>
        <LivePriceTickerVue style="width: 100%"></LivePriceTickerVue>
        <!-- Mobile View Components Sequence -->
        <div class="component-container" style="margin-top: 30px">
          <LatestRecommendations :recommendations="latestRecos" :isRecoListLoading="isRecoListLoading" @get_reco_details="recoDetails" />
        </div>

        <div class="component-container">
          <!-- Scroll wrapper for carousel -->
          <div class="scroll-wrapper">
            <DataCategorisationCarousel />
          </div>
        </div>

        <div class="component-container">
          <MarketCapRecommendations :marketCapRecommendations="marketCapRecommendations" :isRecoListLoading="isRecoListLoading" />
        </div>

        <div class="component-container bottom-margin-10">
          <StampListComponent :stampList="stamp_list" :isRecoListLoading="isRecoListLoading" />
        </div>

        <div class="component-container">
          <PriceRangeWiseRecos :stocksFromMainPage="priceRangeWiseStocks" @get_reco_details="recoDetails" />
        </div>

        <div class="component-container">
          <TopPotentialStockStrategy :recommendations="topPotentialRecommendations" :expertView="'Equity'" :recoCount="topPotentialRecoCount" :isRecoListLoading="isRecoListLoading" @get_reco_details="recoDetails"></TopPotentialStockStrategy>
          <!-- <TopPotentialStockStrategy :strategies="topPotentialStrategyList" :expertView="'Options'" :isRecoListLoading="isRecoListLoading"></TopPotentialStockStrategy> -->
          <!-- <TopPotentialStocks /> -->
        </div>

        <div class="component-container">
          <ChatWithExperts :expert_list="chatExpertList" />
        </div>

        <div class="component-container">
          <MtfApprovedRecos :mtfApprovedStocks="mtfApprovedStocks" @get_reco_details="recoDetails" />
        </div>

        <div class="component-container" style="margin-bottom: 50px">
          <NewsSectionComponent @open-news-popup="showNewsPopup" />

          <!-- Use the component without `.sync` -->
          <NewsPopupComponent :isVisible="isNewsPopupVisible" :newsData="selectedNews" @update:isVisible="isNewsPopupVisible = $event" />
        </div>
      </template>
    </div>
    <!-- </span> -->

    <StockDialog v-if="isStockDetailsDialogVisible" :isStockDetailsDialogVisible.sync="isStockDetailsDialogVisible" :reco_data="reco_data" />

    <div v-if="userProfile != null">
      <ProcessKycComponent :planDetails="planSubscriptionStatusDetails"></ProcessKycComponent>
    </div>

    <div class="sentiment-card-dialog">
      <el-dialog :visible.sync="showTradeDialogue" :before-close="handleClose">
        <div>
          <Trade v-if="isDataChanged" />
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import LivePriceTickerVue from '../components/LivePriceTicker.vue';
import MobileNav from '@/components/MobileNav.vue';
import DataCategorisationLeftSection from '@/components/DataCategorisationLeftSection.vue';
import DataCategorisationCarousel from '@/components/DataCategorisationCarousel.vue';
import MarketCapRecommendations from '@/components/MarketCapRecommendations.vue';
import LatestRecommendations from '@/components/LatestRecommendations.vue';
import PriceRangeWiseRecos from '@/components/PriceRangeWiseRecos.vue';
import TopPotentialStockStrategy from '@/components/TopPotentialsRecos.vue';
import ChatWithExperts from '@/components/ChatWithExperts.vue';
import MtfApprovedRecos from '@/components/MtfApprovedRecos.vue';
import MarketsTop5 from '@/components/MarketsTop5.vue';
import { screenSize } from '../mixins/ScreenSize.js';
import { serverAddr, serverHostName } from '../networkConfig';
import TopPotentialStocks from '@/components/TopPotentialStocks.vue';
import StockDialog from '@/components/StockDialog.vue';
import ProcessKycComponent from '@/components/NewKycFlow.vue';
import { updateProfileNetworkCallBack } from '../mixins/UpdateProfile.NetworkCallBack';
import NewsSectionComponent from '@/components/NewsSectionComponent.vue';
import NewsPopupComponent from '@/components/NewsPopupComponent.vue';
import StampListComponent from '@/components/StampListComponent.vue';
import moment from 'moment';
import { HelperNetworkCallBack } from '../mixins/Helper';
import Trade from '@/components/Trade.vue';

export default {
  name: 'DataCategorisation',
  mixins: [screenSize, updateProfileNetworkCallBack, HelperNetworkCallBack],
  components: {
    MobileNav,
    DataCategorisationLeftSection,
    DataCategorisationCarousel,
    MarketCapRecommendations,
    LatestRecommendations,
    PriceRangeWiseRecos,
    TopPotentialStocks,
    ChatWithExperts,
    MtfApprovedRecos,
    MarketsTop5,
    TopPotentialStockStrategy,
    StockDialog,
    ProcessKycComponent,
    NewsSectionComponent,
    NewsPopupComponent,
    Trade,
    StampListComponent,
    LivePriceTickerVue,
  },

  data() {
    return {
      nav_title: 'Data Categorisation',
      serverHostName: serverHostName,
      isMobile: false,
      isRecoListLoading: false,
      topPotentialStrategyList: [],
      topPotentialRecommendations: [],
      topPotentialRecoCount: 0,
      priceRangeWiseStocks: [],
      mtfApprovedStocks: [],
      latestRecos: [],
      marketCapRecommendations: [],
      chatExpertList: [],
      serverHostName: serverHostName,
      isStockDetailsDialogVisible: false,
      reco_data: {},
      userProfile: {},
      planSubscriptionStatusDetails: null,
      isNewsPopupVisible: false,
      selectedNews: null,
      websiteUserType: {},
      isDataChanged: false,
      stamp_list: [
        { name: 'SIP', icon: require('../assets/images/SIP.svg') },
        { name: 'Momentum Picks', icon: require('../assets/images/MomentumPicks.svg') },
        { name: 'FII/DII Activity', icon: require('../assets/images/FIIActivity.svg') },
        { name: 'News based', icon: require('../assets/images/NewsBased.svg') },
        { name: 'Undiscovered gems', icon: require('../assets/images/undiscovedGems.svg') },
        { name: 'Multibagger', icon: require('../assets/images/Multibegger.svg') },
      ],
    };
  },

  created() {
    if (!localStorage.getItem('currentEnvironment')) {
      this.selectUserType();
    }
    this.userProfile = JSON.parse(localStorage.getItem('profile'));
  },

  mounted() {
    // Call getUserProfile initially
    this.getUserProfile();

    // select user type for navigation access
    if (localStorage.getItem('websiteUserType')) {
      this.websiteUserType = JSON.parse(localStorage.getItem('websiteUserType'));
    }

    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);

    this.fetchAllData();
  },

  beforeRouteEnter(to, from, next) {
    var userPlan = JSON.parse(localStorage.getItem('plan_details'));

    if (!userPlan || (userPlan && userPlan.plan == 'Lite')) {
      next('/expert-view-lite');
    } else {
      next();
    }
  },

  methods: {
    showNewsPopup(news) {
      this.selectedNews = news;
      this.isNewsPopupVisible = true;
    },
    formatDate(date) {
      return moment(date).format('MMM DD, YYYY hh:mm A');
    },

    recoDetails(reco, action) {
      var reco_id = reco.id;

      serverAddr
        .post('recommendation/v1/read_recommendation', { id: reco_id })
        .then((response) => {
          if (response.data && response.data.status) {
            let data = response.data.data;

            this.reco_data = data[0];

            if (action == 'recoPopup') {
              if (this.reco_data.brokerage_data && this.reco_data.brokerage_data.IntraDay) {
                this.reco_data.brokerage_list_type = 'IntraDay';
                this.$set(this.reco_data, 'selected_brokerage_list', this.reco_data.brokerage_data.IntraDay[0].data);
                this.$set(this.reco_data, 'brokerage_list_type', 'IntraDay');
                this.$set(this.reco_data, 'reco_quantity', 1);
                this.$set(this.reco_data, 'logic_description', this.reco_data.report.length ? this.reco_data.report[0].description : '');

                if (this.reco_data.brokerage_data.IntraDay[0].exp_tax) {
                  this.$set(this.reco_data, 'exp_tax', this.reco_data.brokerage_data.IntraDay[0].exp_tax);
                } else {
                  this.$set(this.reco_data, 'exp_tax', this.reco_data.brokerage_data.IntraDay[0].data.total_tax_and_charges);
                }
              }
              // Open StockDialog with the filtered reco_data
              this.isStockDetailsDialogVisible = true;
            } else {
              this.openTradePopup(this.reco_data);
            }
          } else {
            console.error('Failed to fetch recommendation details:', response.data.message);
          }
        })
        .catch((error) => {
          console.error('API Error:', error);
        })
        .finally(() => {
          this.isRecoListLoading = false;
        });
    },
    //     openTradePopup(reco){
    // console.log('tradeeeeee');

    //     },
    openTradePopup(stockDetails) {
      var stockData = {};
      stockData.segment = 'equity';
      stockData.symbol = stockDetails.stock.symbol;
      stockData.stock_id = stockDetails.stock.id;
      stockData.stop_loss = stockDetails.stop_loss;
      stockData.target_price = stockDetails.target_price;
      stockData.order_type = stockDetails.reco;
      stockData.entry_price = stockDetails.reco_open_price;
      stockData.ltp = stockDetails.stock.current_price;
      stockData.duration = stockDetails.duration;

      if (this.isTradeVisible()) {
        if (stockDetails.reco == 'Buy') {
          // set parameters for pre selected stock in trade button
          this.$store.commit('commitTradeMenu', 'TRADE');
          this.$store.commit('commitSelectedOrder', stockData);
          this.$store.commit('tradePopupAction', true);
          this.isDataChanged = true;
        } else if (stockDetails.reco == 'Sell') {
          this.isVisibleSellNotAllowedPopup = true;
        }
      } else {
        if (this.websiteUserType.userType != 'broker') {
          this.$store.commit('commitBrokerLoginDialogVisibility', true);
          this.$store.commit('commitSelectedOrder', stockData);
        } else {
          this.$store.commit('commitSubscribPlanDialogVisibility', true);
        }
      }
    },

    handleClose() {
      this.isDataChanged = false;
      this.$store.commit('tradePopupAction', false);
    },

    getRiskLevelClass(riskTag) {
      switch (riskTag) {
        case 'High':
          return 'high-risk';
        case 'Medium':
          return 'medium-risk';
        case 'Low':
          return 'low-risk';
        default:
          return 'default-risk';
      }
    },

    getUserProfile() {
      this.is_profile_save_loading = true;

      serverAddr
        .get('/auth/v1/profile')
        .then(this.getProfileCallBack)
        .catch(function (error) {
          console.log(error);
        });
    },

    async fetchAllData() {
      this.isRecoListLoading = true; // Start loader
      // topStrategies
      try {
        const [latestRecommendation, chatExpertList, marketCapWiseRecommendation, recommendations, priceRangeWiseRecommendation, mtfApprovedStock] = await Promise.allSettled([
          this.getLatestRecommendation(),
          this.getExpertProfiles(),
          this.getMarketCapWiseRecommendation(),
          // this.getTopStrategies(),
          this.getRecommendations(),
          this.getPriceRangeWiseRecommendation(), // Pass a range here (example: below500)
          this.getMtfApprovedStock(),
        ]);

        // Handle `latestRecommendation`
        if (latestRecommendation.status === 'fulfilled') {
          var data = latestRecommendation.value.data;
          if (data.status) {
            this.latestRecos = data.data.map((item) => ({
              reco: item.reco,
              created_at: item.created_at,
              remaining_potential: item.remaining_potential,
              stock_name: item.stock_name,
              user_detail: item.user_detail,
              risk_tag: item.risk_tag,
              stock_logo: item.stock_logo,
              id: item.id,
            }));
          }
        } else {
          console.error('Failed to fetch latest recommendations:', latestRecommendation.reason);
        }

        // Handle `marketCapWiseRecommendation`
        if (marketCapWiseRecommendation.status === 'fulfilled') {
          const data = marketCapWiseRecommendation.value.data;
          if (data.status) {
            // Assuming response data is in 'data.entries(response.data.data)' format
            this.marketCapRecommendations = Object.entries(data.data).map(([cap_name, count]) => ({
              cap_name,
              count,
              bgColor: this.getBackgroundColor(cap_name), // Dynamic background color
            }));

            var capOrder = ['Small Cap', 'Mid Cap', 'Large Cap']; // Define the desired order

            this.marketCapRecommendations.sort((a, b) => capOrder.indexOf(a.cap_name) - capOrder.indexOf(b.cap_name));
          }
        } else {
          console.error('Failed to fetch market cap recommendations:', marketCapWiseRecommendation.reason);
        }

        // Handle `topStrategies`
        // if (topStrategies.status === 'fulfilled') {
        //   var data = topStrategies.value.data;
        //   if (data.status && data.data.length > 0) {
        //     this.topPotentialStrategyList = data.data.map((item) => {
        //       const strategy = item.strategy || {};
        //       const userDetails = strategy.user_details || {};
        //       return {
        //         riskCategory: strategy.risk_tag || 'N/A',
        //         title: strategy.title || 'N/A',
        //         createdDate: strategy.created_date || 'N/A',
        //         avgRemainingPotential: strategy.avg_remaining_potential_in_perc || 0,
        //         direction: strategy.direction || '',
        //         riskTag: strategy.risk_tag || 'N/A',
        //         userProfilePic: userDetails.pic || '',
        //         strategy_id: strategy.id,
        //         userName: userDetails.full_name,
        //         sebiNumber: userDetails.sebi_regi_number,
        //       };
        //     });
        //   }
        // } else {
        //   console.error('Failed to fetch top strategies:', topStrategies.reason);
        // }

        // Handle `topPotentialRecommendations`
        if (recommendations.status === 'fulfilled') {
          var data = recommendations.value.data;
          if (data.data.length) {
            this.topPotentialRecommendations = data.data;
            this.topPotentialRecoCount = data.recommendation_count;
          }
        } else {
          console.error('Failed to fetch recommendations:', recommendations.reason);
        }

        // Handle `priceRangeWiseRecommendation`
        if (priceRangeWiseRecommendation.status === 'fulfilled') {
          var data = priceRangeWiseRecommendation.value.data;

          if (data.status) {
            this.priceRangeWiseStocks = data.data;
          } else {
            this.priceRangeWiseStocks = [];
          }
        } else {
          console.error('Failed to fetch price range recommendations:', priceRangeWiseRecommendation.reason);
        }

        // Handle `mtfApprovedStock`
        if (mtfApprovedStock.status === 'fulfilled') {
          var data = mtfApprovedStock.value.data;
          if (data.status) {
            this.mtfApprovedStocks = data.data.map((item) => ({
              id: item.id,
              reco: item.reco,
              created_at: item.created_at,
              stock_name: item.stock_name,
              remaining_potential: item.remaining_potential,
              user_detail: item.user_detail,
              stock_logo: item.stock_logo,
            }));
          }
        } else {
          console.error('Failed to fetch MTF approved stocks:', mtfApprovedStock.reason);
        }

        // Handle `Chatchat_Expert_List`
        if (chatExpertList.status === 'fulfilled') {
          var data = chatExpertList.value.data;
          if (data.status) {
            this.chatExpertList = data.data.map((item) => ({
              fullName: item.full_name,
              profileImage: item.picture ? `${this.serverHostName}${item.picture}` : require('../assets/images/navBar/avatar.jpg'), // Fallback image
              verifyIcon: require('../assets/images/verify.svg'),
              status: 'offline',
              expertSkills: item.expert_skills,
            }));
          }
        } else {
          console.error('Failed to fetch MTF approved stocks:', chatExpertList.reason);
        }
      } catch (error) {
        console.error('Error in combinedApis:', error);
      } finally {
        this.isRecoListLoading = false; // Stop loader
      }
    },

    getExpertProfiles() {
      return serverAddr
        .get('/user/admin/chat_expert_list')
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getMarketCapWiseRecommendation() {
      return serverAddr
        .get('/recommendation/v1/equity_market_cap_reco_count')
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    getBackgroundColor(cap_name) {
      // Return background color based on cap name
      switch (cap_name) {
        case 'Mid Cap':
          return '#FFF9EC';
        case 'Small Cap':
          return '#E2EFFF';
        case 'Large Cap':
          return '#F0FCFF';
        default:
          return '#ffffff';
      }
    },

    async getLatestRecommendation() {
      return serverAddr
        .get('/recommendation/v1/latest_recommendation')
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    // async getTopStrategies() {
    //   return serverAddr
    //     .get('/options/top_potentai_startegies')
    //     .then((response) => {
    //       return response;
    //     })
    //     .catch(
    //       function (error) {
    //         console.log(error);
    //       }.bind(this)
    //     );
    // },

    async getRecommendations() {
      return serverAddr
        .get('/recommendation/v1/top_potential_recos')
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    async getPriceRangeWiseRecommendation() {
      return serverAddr
        .get(`/recommendation/v1/price_range_wise_recommendation?cmp_range=${'BELOW500'}`)
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    async getMtfApprovedStock() {
      return serverAddr
        .get('/recommendation/v1/mtf_stock_wise_recommendation')
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
    },
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },

  computed: {
    planDetails() {
      return JSON.parse(localStorage.getItem('plan_details'));
    },

    showTradeDialogue() {
      this.isDataChanged = this.$store.state.tradeDialogVisible ? true : false;
      return this.$store.state.tradeDialogVisible;
    },

    // riskLevelClass() {
    //   return {
    //     "high-risk": this.riskLevel === "High Risk",
    //     "moderate-risk": this.riskLevel === "Moderate Risk",
    //     "low-risk": this.riskLevel === "Low Risk",
    //   };
    // },
  },
};
</script>

<style lang="scss" scoped>
.data-categorisation {
  background-color: #f4f4f4;
  display: flex;
  min-height: 100vh;
  overflow-x: hidden;

  // .page-container {
  //   margin-top: 40px;
  // }

  .DataCategorisationLeftSection {
    width: 350px;
    position: fixed;
    height: calc(100% - 80px);
    overflow-y: scroll;
    margin-top: 105px;
    padding: 20px;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .right-section {
    margin-left: 370px;
    padding: 20px;
    margin-top: 105px;
    color: black;
    width: calc(100% - 410px);

    .flex-sections,
    .component-container {
      margin-top: 20px;
    }
  }

  .responsive-col {
    @media (max-width: 1050px) {
      &:nth-child(odd),
      &:nth-child(even) {
        width: 100%;
        margin-bottom: 20px;
      }
    }
  }

  @media (max-width: 1170px) {
    .right-section {
      margin-bottom: 40px;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    overflow-x: hidden;
    padding: 0px;

    .right-section {
      margin-left: 0;
      width: 100%;
      padding: 0px;
      margin-bottom: 0px;
    }

    .component-container {
      width: 95%;
      margin: 0 auto;
    }
  }

  .scroll-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
    height: auto;

    &::-webkit-scrollbar {
      height: 8px;
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 5px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }

  .el-loading-mask {
    .el-loading-spinner {
      top: 40vh;
    }
  }
}
</style>

<style lang="scss">
.data-categorisation {
  // }
  .sentiment-card-dialog {
    .tab-market-sentiment {
      .stock-details {
        margin: 15px;
      }

      .sentiment-options {
        display: none;
      }

      .el-card__body,
      .el-main {
        padding: 0;
      }

      .box-card {
        margin: 0;
      }
    }

    .el-dialog {
      margin-top: 100px;
      width: 550px;
      border-radius: 8px;
    }

    .el-dialog__body,
    .el-dialog__header {
      padding: 0px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      z-index: 2;
      position: relative;
    }

    .box-card {
      border-radius: 10px !important;
      border: none;
      box-shadow: none;
    }

    .box-card-two {
      margin: 5px;
    }

    .employee-select-box .el-input--mini .el-input__inner {
      height: 25px;
      border-radius: 8px;
      text-transform: capitalize;
    }

    .el-progress-bar {
      padding: 0;
    }

    .el-progress__text {
      display: none;
    }

    .vuejs-countdown .digit {
      font-size: 28px;
    }

    .el-checkbox__inner {
      border-radius: 4px;
    }
  }

  @media (max-width: 768px) {
    .component-container .header {
      font-size: 13px;
      font-weight: 600;
      .view-all {
        font-size: 12px;
      }
    }
  }

  @media screen and (max-width: 600px) {
    .sentiment-card-dialog {
      .el-dialog {
        margin-top: 20px;
        width: 95%;
      }
    }
  }
}
</style>